// @flow

import { rem } from 'polished';
import styled from 'styled-components';

const Container = styled.div`
  height: ${rem(136)};
  width: ${rem(136)};
`;

export default Container;
